import { fromJS } from 'immutable';

import * as ActionType from '../actions/dialPadCall';

const defaultState = fromJS({
  loaded: false,
  data: null,
});

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case ActionType.SEND_OUTGOING_CALL_DIAL_PAD_SUCCESS:
      return state.merge({
        loaded: true,
        data: action.response.data,
      });

    default:
      return state;
  }
}
